import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { XpoApplication } from '../models/application.model';

@Injectable()
export class XpoApplicationSwitcherService {
  favoriteApplicationChange$: Subject<XpoApplication> = new Subject<XpoApplication>();
}
